import { Modal } from 'react-bootstrap';
import ActivatedIcon from 'assets/img/verification/verified.svg';
import Button from 'components/base/Button';

interface Props {
  show: boolean;
  handleSubmit: () => void;
  name: string;
  organizationName: string;
}

const InviteSuccessModal = ({
  show,
  handleSubmit,
  name,
  organizationName
}: Props) => {
  return (
    <Modal show={show} onHide={handleSubmit} className="p-0" centered>
      <Modal.Body className="pt-4 pb-2 px-4">
        <div className="d-flex justify-content-center mb-2">
          <img src={ActivatedIcon} width={150} alt="Success Icon" />
        </div>
        <h5 className="text-center fs-6">Invitation Accepted!</h5>
        <p className="mt-3 text-center">
          Congratulations, {name}! Your invitation has been successfully
          verified. Thank you for joining {organizationName}.
        </p>
        <div className="d-flex justify-content-center mb-2">
          <Button variant="outline-primary" onClick={handleSubmit}>
            Continue
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default InviteSuccessModal;
